import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show toast after 5 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Hide toast after 10 seconds of showing
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-4 flex items-start gap-4 max-w-sm" data-id="element-192">
          <div className="bg-amber-500/10 p-2 rounded-full mt-1" data-id="element-193">
            <CheckCircle2 className="w-5 h-5 text-amber-500" data-id="element-194" />
          </div>
          <div data-id="element-195">
            <p className="text-sm font-medium text-white" data-id="element-196">Carlos (Madrid)</p>
            <p className="text-xs text-zinc-400 mt-0.5" data-id="element-197">
              Acaba de comprar el Fotógrafo Pro Kit
            </p>
            <div className="flex items-center gap-1 mt-2 text-[10px] text-zinc-500 uppercase tracking-wider font-semibold" data-id="element-198">
              <MapPin className="w-3 h-3" data-id="element-199" />
              Hace 2 horas • Verificado
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}